var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginated-search',_vm._b({},'paginated-search',{ schema: _vm.schema, searchEntities: _vm.searchEntities, openEntity: _vm.openEntity, createEntity: _vm.createEntity },false))}
var staticRenderFns = []

export { render, staticRenderFns }